module.exports = __webpack_public_path__ + "img/Ling_Tian@2x.91578d9a.png";